<template>
  <div class="dialog-layout">
    <dialog-child ref="dialog" v-bind="$options.propsData" />
  </div>
</template>

<script>
export default {
  name: 'EDialogDefaultLayout',
}
</script>
